import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=4ace409b&scoped=true&"
import script from "./SideBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace409b",
  null
  
)

export default component.exports